import {
  arrayBuilderItemSubsequentPageTitleUI,
  descriptionUI,
} from 'platform/forms-system/src/js/web-component-patterns';
import FileUploadDescription from '../../components/FormDescriptions/FileUploadDescription';
import { attachmentSchema, attachmentUI } from '../../definitions';
import content from '../../locales/en/content.json';
import { ATTACHMENT_IDS } from '../../utils/constants';

const TITLE_TEXT = content['medicare--part-d-card-title'];
const DESC_TEXT = content['medicare--part-d-card-description'];
const INPUT_LABELS = {
  front: content['medicare--part-d-card-label--front'],
  back: content['medicare--part-d-card-label--back'],
};
const HINT_TEXT = content['attachments--hint-text'];

export default {
  uiSchema: {
    ...arrayBuilderItemSubsequentPageTitleUI(TITLE_TEXT, DESC_TEXT),
    ...descriptionUI(FileUploadDescription),
    medicarePartDFrontCard: attachmentUI({
      title: INPUT_LABELS.front,
      hint: HINT_TEXT,
      attachmentId: ATTACHMENT_IDS.medicareDCardFront,
    }),
    medicarePartDBackCard: attachmentUI({
      title: INPUT_LABELS.back,
      hint: HINT_TEXT,
      attachmentId: ATTACHMENT_IDS.medicareDCardBack,
    }),
  },
  schema: {
    type: 'object',
    required: ['medicarePartDFrontCard', 'medicarePartDBackCard'],
    properties: {
      medicarePartDFrontCard: attachmentSchema,
      medicarePartDBackCard: attachmentSchema,
    },
  },
};
